var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-notification',{attrs:{"closable":false,"role":"alert","type":"is-info is-light"}},[_c('p',{staticClass:"pb-0 mb-0"},[_c('i',{staticClass:"fa fa-exclamation-triangle mr-1"}),_vm._v(" Vous relisez actuellement une commande écrite par "+_vm._s(_vm.writing.redactor.user.firstname)+" "+_vm._s(_vm.writing.redactor.user.lastname)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }